import { authRoutes, groupAuthId } from '@/router/routes';
import Store from '../../store';
import {
    SET_INFO_FROM_LOCAL
} from '../../store/mutationTypes';
import resolveAppInfo from '../../utils/loginInfo';

export default (router) => {
    let status = false;
    let firstNotFound = true;
    router.beforeEach(async (to, from, next) => {
        // do something
        if (!status) {
            status = true;
            resolveAppInfo(async (info) => {
                await Store.commit(SET_INFO_FROM_LOCAL, info);
            });
        }
        if (from.path === '/' && (to.path === '/home' || to.path === '/login')) {
            if (to.path === '/login') {
                firstNotFound = true;
                await Store.dispatch('setRouter', 0);
            }
            next();
        } else if (to.name !== 'login') {
            try {
                const routerState = Store.getters.getRouterState;
                if (!routerState) {
                    await Store.dispatch('setRouter', 1);
                    await Store.dispatch('getUserAuth');
                    const authLIst = Store.getters.getAuthList;
                    const loginType = Store.getters.getLoginType;
                    const newRouter = [];
                    authRoutes.forEach((item) => {
                        if (item.path !== '/' && item.path !== '/home' && item.path !== '/login' && item.path !== '/vipExplain' && item.name !== 'pageNotFound') {
                            if (item.meta.pageId) {
                                if (item.meta.pageId === 'role') {
                                    if (loginType === 1 || loginType === '1') newRouter.push(item);
                                } else if (authLIst.indexOf(item.meta.pageId) !== -1) {
                                    newRouter.push(item);
                                }
                            } else if (item.meta.pageGroup) {
                                if (item.meta.pageGroup === 'home') {
                                    newRouter.push(item);
                                } else if (authLIst.indexOf(groupAuthId[item.meta.pageGroup]) !== -1) {
                                    newRouter.push(item);
                                }
                            } else if (!item.meta.pageGroup) {
                                newRouter.push(item);
                            }
                        }
                    });
                    await router.addRoutes(newRouter);
                    next({path: to.path, query: to.query});
                } else if (to.name === 'pageNotFound' && firstNotFound) { // 有了路由且首次进404
                    firstNotFound = false;
                    next({path: to.path, query: to.query});
                }
            } catch (error) {
                await Store.dispatch('setRouter', 0);
                next('/login');
            }
        } else {
            if (to.path === '/login') {
                firstNotFound = true;
            }
            await Store.dispatch('setRouter', 0);
        }
        next();
    });
};



// WEBPACK FOOTER //
// ./src/router/middlewares/insetInfo.js